<!-- 销售订单 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <orderpoolQueryDetail v-if="showStatus" ref="orderpoolQueryDetail" @drawerCancel="drawerCancel" :actionData="actionData"></orderpoolQueryDetail>
        </el-drawer>
        <!--  -->
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="spd订单列表" name="first">
                <div class="page_content_top" style="margin-top: 5px;">
                    <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
                    <div class="page_content_top_line">
                        <v-search v-if="pageShowData.jurHead" :flagList="['orderState']" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                            <template slot="searchInput" slot-scope="{formOneValue}">
                                <el-select filterable v-if="formOneValue.entityField == 'orderState'" v-model="getRequestData[formOneValue.entityField]">
                                    <el-option v-for="(values, keys) in JSON.parse(formOneValue.formatterContent)" :key="keys" :label="values.value" :value="values.key">
                                    </el-option>
                                </el-select>
                            </template>
                        </v-search>

                    </div>
                </div>
                <div class="page_content_center">
                    <el-table v-if="pageShowData.jurTableVo" class="table1" stripe :data="returnData.list" :height="(tableHeight / 2) + 50" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini"
                        @selection-change="handleSelectionChange" @current-change="handleCurrentChange">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                            <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
                                <template slot-scope="scope">
                                    <span v-if="tableValye.fieldType == 'date'">
                                        <span v-if="scope.row[tableValye.entityField]">
                                            {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                        </span>
                                    </span>
                                    <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                        {{ scope.row.isWms == 0 ? '否' : '是' }}
                                    </el-tag>
                                    <span v-else-if="tableValye.isRift == 1">
                                        <a @click="toDetail(scope.row[tableValye.riftField])">{{
                              scope.row[tableValye.entityField] }}</a>
                                    </span>
                                    <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                                        {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField])
                           }}</el-tag>
                                    <span v-else>
                                        {{ scope.row[tableValye.entityField] }}
                                    </span>
                                </template>
                            </el-table-column>
                        </template>
                    </el-table>
                    <div class="page_content_bottom">
                        <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
                    </div>
                    <el-table v-if="detailTableColumns.length > 0" class="table1" stripe :data="returnData.detailsList" :height="(tableHeight / 2) - 50" border style="width: 100%" highlight-current-row size="mini">
                        <el-table-column label="操作" width="120" align="center">
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini" @click="bindBgmDetail(scope.row)">
                                    绑定商品
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" v-for="(tableValye, tableKey) in detailTableColumns" :key="'detail_' + tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField"
                            :label="tableValye.showField">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                </span>
                                <span v-else-if="tableValye.fieldType == 'dateTime'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                                    </span>
                                </span>
                                <span v-else-if="tableValye.fieldType == 'number'">
                                    {{ scope.row[tableValye.entityField] || 0 }}
                                </span>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{
                              scope.row[tableValye.entityField] }}</a>
                                </span>
                                <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                                    {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField])
                           }}</el-tag>
                                <span v-else>
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="结算单列表" name="second">
                <div class="page_content_top" style="margin-top: 5px;">
                    <div class="page_content_top_line">
                        <v-search v-if="pageShowData.jurHead" :flagList="['orderState']" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                            <template slot="searchInput" slot-scope="{formOneValue}">
                                <el-select filterable v-if="formOneValue.entityField == 'orderState'" v-model="getRequestData[formOneValue.entityField]">
                                    <el-option v-for="(values, keys) in JSON.parse(formOneValue.formatterContent)" :key="keys" :label="values.value" :value="values.key">
                                    </el-option>
                                </el-select>
                            </template>
                        </v-search>

                    </div>
                </div>
                <div class="page_content_center">
                    <el-table v-if="pageShowData.jurTableVo" class="table1" stripe :data="returnData.list" :height="(tableHeight / 2) + 50" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini"
                        @selection-change="handleSelectionChange" @current-change="handleCurrentChange">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                            <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
                                <template slot-scope="scope">
                                    <span v-if="tableValye.fieldType == 'date'">
                                        <span v-if="scope.row[tableValye.entityField]">
                                            {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                        </span>
                                    </span>
                                    <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                        {{ scope.row.isWms == 0 ? '否' : '是' }}
                                    </el-tag>
                                    <span v-else-if="tableValye.isRift == 1">
                                        <a @click="toDetail(scope.row[tableValye.riftField])">{{
                              scope.row[tableValye.entityField] }}</a>
                                    </span>
                                    <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                                        {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField])
                           }}</el-tag>
                                    <span v-else>
                                        {{ scope.row[tableValye.entityField] }}
                                    </span>
                                </template>
                            </el-table-column>
                        </template>
                    </el-table>
                    <div class="page_content_bottom">
                        <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
                    </div>
                    <el-table v-if="detailTableColumns.length > 0" class="table1" stripe :data="returnData.detailsList" :height="(tableHeight / 2) - 50" border style="width: 100%" highlight-current-row size="mini">
                        <el-table-column align="center" v-for="(tableValye, tableKey) in detailTableColumns" :key="'detail_' + tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField"
                            :label="tableValye.showField">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                </span>
                                <span v-else-if="tableValye.fieldType == 'dateTime'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                                    </span>
                                </span>
                                <span v-else-if="tableValye.fieldType == 'number'">
                                    {{ scope.row[tableValye.entityField] || 0 }}
                                </span>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{
                              scope.row[tableValye.entityField] }}</a>
                                </span>
                                <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                                    {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField])
                           }}</el-tag>
                                <span v-else>
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>
        <!--  -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" append-to-body>
            <div class="bgmObj" v-if="bgmShow">
                <p v-if="bgmCodeObj.bgmName">
                    <span>通用名称:</span>
                    <span>{{ bgmCodeObj.bgmName }}</span>
                </p>
                <p v-if="bgmCodeObj.bgiGename">
                    <span>商品名称:</span>
                    <span>{{ bgmCodeObj.bgiGename }}</span>
                </p>
                <p v-if="bgmCodeObj.erpBgmCode">
                    <span>ERP商品编码:</span>
                    <span>{{ bgmCodeObj.erpBgmCode }}</span>
                </p>
                <p v-if="bgmCodeObj.bgmCode">
                    <span>spd商品编码:</span>
                    <span>{{ bgmCodeObj.bgmCode }}</span>
                </p>
                <p v-if="bgmCodeObj.spec">
                    <span>规格:</span>
                    <span>{{ bgmCodeObj.spec }}</span>
                </p>
                <p v-if="bgmCodeObj.manufacturer">
                    <span>生产商:</span>
                    <span>{{ bgmCodeObj.manufacturer }}</span>
                </p>
                <p v-if="bgmCodeObj.bgiAppnumber">
                    <span>批准文号:</span>
                    <span>{{ bgmCodeObj.bgiAppnumber }}</span>
                </p>
            </div>
            <div class="bgmObj" v-if="cmShow">
                <p v-if="cmCodeObj.unitName">
                    <span>单位名称:</span>
                    <span>{{ cmCodeObj.unitName }}</span>
                </p>
                <p v-if="cmCodeObj.platcmId">
                    <span>平台单位编号:</span>
                    <span>{{ cmCodeObj.platcmId }}</span>
                </p>
            </div>
            <SearchScheme :oneFlag="oneFlag" ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../../byComponents/SearchScheme.vue"
import orderpoolQueryDetail from "@/components/orderpoolQueryDetail.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme, orderpoolQueryDetail },
    data() {
        //这里存放数据
        return {
            title: "",
            info: {
                cmName: '',
                cmId: '',
                smName: '',
                smId: '',
                poolId: '',
            },
            bgmInfo: {
                bgmName: '',
                bgmId: '',
            },
            bgmShow: false,
            cmShow: false,
            oneFlag: false,
            bgmCodeObj: {
                bgmName: '',
                bgiGename: '',
                erpBgmCode: '',
                spec: '',
                manufacturer: '',
                bgiAppnumber: '',
                bgmCode: "",
            },
            cmCodeObj: {
                platcmId: "",
                unitName: '',
            },
            currentDetailRow: null, // 当前要绑定商品的明细行
            tableHeight: 0,
            getRequestData: {
                unitName: "",//单位名称
                businessId: "",
                orderState: "",  //
                page: 1,
                rows: 30,
                start: '',	//开始上一个月
                end: '',	//当天最后时间
            },
            returnData: {
                pages: 0,  // 总页数
                total: 0,  // 总条数
                pageNum: 0,  // 当前页数
                list: [],
                detailsList: []  // 明细列表
            },
            sField: '',
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            seTitle: "",//检索
            DialogVisible: false,
            seWidth: '0',
            seId: 0,
            smId: 0,
            showStatus: false,
            actionData: {},
            parentSearchData: {},
            multipleSelection: [],
            activeName: "first",
        };
    },
    //监听属性 类似于data概念
    computed: {
        // 明细表格列配置
        detailTableColumns() {
            if (this.pageShowData && this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.length > 0) {
                const detailForm = this.pageShowData.jurFormVoList[0];
                if (detailForm && detailForm.jurconfigform) {
                    return detailForm.jurconfigform.filter(item => item.isShow == 1);
                }
            }
            return [];
        }
    },
    //监控data中的数据变化
    watch: {
        'getRequestData.smName': {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.getRequestData.smId = ''
                }
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        // 
        handleClick(val) {
            if (this.activeName == 'first') {
                console.log("第一个选项卡");
            } else if (this.activeName == 'second') {
                console.log("第二个选项卡");
            }
            this.getPageInfo()
            // this.getDataList()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
            // 当选择发生变化时，获取所有选中行的明细数据
            if (val && val.length > 0) {
                this.getSelectedRowsDetails(val);
            } else {
                // 如果没有选中任何行，清空明细数据
                this.returnData.detailsList = [];
            }
        },
        // 处理主表行选择变化，加载对应明细
        handleCurrentChange(currentRow) {
            if (currentRow) {

            } else {
                this.returnData.detailsList = [];
            }
        },
        // 获取选中行的明细数据
        async getSelectedRowsDetails(selectedRows) {
            try {
                // 提取所有选中行的订单ID
                const orderIds = this.activeName === "first" ? selectedRows.map(row => row.orderId).filter(id => id) : [selectedRows[0].vsourcebillid];

                if (orderIds.length === 0) {
                    this.returnData.detailsList = [];
                    return;
                }
                console.log('获取选中行明细数据，订单IDs:', orderIds);

                // 调用明细接口
                const params = {
                    ids: orderIds
                };

                const response = this.activeName === "first" ? await this.$http.orderpoolQuerySpdDetail(params) : await this.$http.orderpoolQuerySpdDetail2(params);
                if (response && response.status === 200) {
                    this.returnData.detailsList = response.result.list || response.result || [];
                    console.log('明细数据获取成功:', this.returnData.detailsList);
                } else {
                    this.$message.error('获取明细数据失败: ' + (response.message || '未知错误'));
                    this.returnData.detailsList = [];
                }

            } catch (error) {
                console.error('获取选中行明细数据失败:', error);
                this.$message.error('获取明细数据失败');
                this.returnData.detailsList = [];
            }
        },
        // 绑定商品明细方法
        bindBgmDetail(row) {
            this.currentDetailRow = row;
            this.bgmInfo.bgmName = '';
            this.bgmInfo.bgmId = '';
            this.bgmCodeObj = {
                bgmName: row.bgmName || row.goodsName || '',
                bgiGename: row.bgiGename || '',
                bgmCode: row.bgmCode || '',
                erpBgmCode: row.erpBgmCode || '',
                spec: row.spec || '',
                manufacturer: row.manufacturer || '',
                bgiAppnumber: row.bgiAppnumber || row.appNumber || '',
            };
            this.openSearch1('8820873997127718', 0, 'bgmName', 'bgmName,bgmId')
        },
        // 确定绑定商品
        async sureSubmitBgm() {
            if (!this.bgmInfo.bgmId || !this.bgmInfo.bgmName) {
                this.$message.warning('请选择要绑定的商品');
                return;
            }

            try {
                const params = {
                    poolDetailId: this.currentDetailRow.pooldetailId,
                    bgmId: this.bgmInfo.bgmId,
                    bgmName: this.bgmInfo.bgmName
                };

                const responseData = await this.$http.orderpoolBindBgmSpd(params);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message || '绑定商品成功');
                    // 重新加载明细数据
                    if (this.multipleSelection.length > 0) {
                        this.getSelectedRowsDetails(this.multipleSelection);
                    }
                } else {
                    this.$message.error(responseData.message || '绑定商品失败');
                }
            } catch (error) {
                console.error('绑定商品失败:', error);
                this.$message.error('绑定商品失败');
            }
        },
        // 子组件触发
        drawerCancel() {
            this.showStatus = false
            this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                sessionStorage.setItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({  //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: { isPenetrate } //参数
                }, '*');
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, index, type, sField }) {
            this.bgmShow = false
            this.cmShow = false
            this.oneFlag = false
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        // 检索Id, 索引(表格中), 标识
        openSearch1(sId, index, type, sField) {
            this.bgmShow = false
            this.cmShow = false
            this.oneFlag = false
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            if (type == 'bgmName') {
                this.bgmShow = true
                this.oneFlag = true
                this.parentSearchData[type] = this.bgmCodeObj.bgmName
            } else if (type == 'cmName' || type == 'smName') {
                this.cmShow = true
                this.oneFlag = true
                this.parentSearchData[type] = this.cmCodeObj.unitName
            } else {
                this.parentSearchData[type] = this.info[type]
            }
        },
        //检索带回数据
        changeInputModel(val) {
            if (val && val != "") {
                this.DialogVisible = false;
                if (this.seId == '155784192757760') {
                    this.info.smId = val.smId
                    this.info.smName = val.smName
                    this.sureSubmitsm()
                } else if (this.seId == '8820873997127718') {
                    this.bgmInfo.bgmId = val.bgmId
                    this.bgmInfo.bgmName = val.bgmName
                    this.sureSubmitBgm()
                } else if (this.seId == '3391151360249856') {
                    this.info.cmId = val.cmId
                    this.info.cmName = val.cmName
                    this.sureSubmitsm()
                } else {
                    this.paramValue(val)
                }
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },
        isShowData(name, value) {
            switch (name) {
                case 'customerList':
                    var dataInfo = sessionStorage.getItem('selectCustomerData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.getRequestData.smId = dataInfo.smId
                        this.getRequestData.smName = dataInfo.smName
                    }

                    break;

                default:
                    this.getRequestData[name] = value

            }
        },

        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({ ids: this.activeName === 'second' ? [1609378973357] : [pathId.jurId] })
            // let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
            if (responseData.status == 200) {
                this.getButtonList()
                this.pageShowData = responseData.result
                this.formDataList = this.pageShowData.jurFormVoList[0].jurconfigform
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        async sureSubmitsm() {
            if (this.title == '绑定供应商') {
                if (!this.info.smId || !this.info.smName) {
                    this.$message.warning('请选择要绑定的供应商');
                    return;
                }
            } else {
                if (!this.info.cmId || !this.info.cmName) {
                    this.$message.warning('请选择要绑定的客户');
                    return;
                }
            }
            try {
                let responseData;
                if (this.title == '绑定供应商') {
                    responseData = await this.$http.orderpoolBindUnitSpd(this.info)
                } else {
                    responseData = await this.$http.orderbindCmSpd(this.info)
                }
                if (responseData.status == 200) {
                    this.$message.success(responseData.message || (this.title == '绑定供应商' ? '绑定供应商成功' : '绑定客户成功'))
                    this.getDataList()
                } else {
                    this.$message.error(responseData.message || (this.title == '绑定供应商' ? '绑定供应商失败' : '绑定客户失败'))
                }
            } catch (error) {
                console.error(this.title + '失败:', error);
                this.$message.error(this.title == '绑定供应商' ? '绑定供应商失败' : '绑定客户失败');
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType);
            switch (actionData.actionType) {
                case 0:
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    if (this.multipleSelection.length != 1) {
                        this.$message({
                            message: '请先选中一条要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    var dataInfo = this.multipleSelection[0]
                    this.showStatus = true
                    this.actionData = {
                        cate: 2, formData: this.pageShowData.jurTableVo,
                        oldData: dataInfo, orderId: dataInfo.orderId, printSouce: '',
                        printJurId: '', type: 'one'
                    }
                    break;
                case 1://修改
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    if (this.multipleSelection.length != 1) {
                        this.$message({
                            message: '请先选中一条要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    var dataInfo = this.multipleSelection[0]
                    this.showStatus = true
                    this.actionData = {
                        cate: 1, formData: this.pageShowData.jurTableVo,
                        oldData: dataInfo, orderId: dataInfo.orderId, printSouce: '',
                        printJurId: '', type: 'one'
                    }
                    break;
                case 2:
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.del()
                    break;
                case 3:
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    if (this.multipleSelection.length != 1) {
                        this.$message({
                            message: '请先选中一条要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    var dataInfo = this.multipleSelection[0]
                    if (dataInfo.orderState != 0 && dataInfo.orderState != -1) {
                        return this.$message({
                            message: '该状态不允许修改绑定单位',
                            type: 'error'
                        });
                    }
                    this.info.smId = ''
                    this.info.smName = ''
                    this.info.cmId = ''
                    this.info.cmName = ''
                    this.title = '绑定供应商'
                    this.info.poolId = dataInfo.poolId
                    this.cmCodeObj = {
                        unitName: dataInfo.unitName || dataInfo.smName || '',
                        platcmId: dataInfo.platcmId || '',
                    }
                    this.openSearch1('155784192757760', 0, 'smName', 'smName,smId')
                    break;
                case 6://重置
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.resetInit()
                    break;
                case 10://关闭
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.closePool()
                    break;
                case 7://绑定客户
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    if (this.multipleSelection.length != 1) {
                        this.$message({
                            message: '请先选中一条要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    var dataInfo = this.multipleSelection[0]
                    if (dataInfo.orderState != 0 && dataInfo.orderState != -1) {
                        return this.$message({
                            message: '该状态不允许修改绑定单位',
                            type: 'error'
                        });
                    }
                    this.info.smId = ''
                    this.info.smName = ''
                    this.info.cmId = ''
                    this.info.cmName = ''
                    this.info.poolId = dataInfo.poolId
                    this.title = '绑定客户'
                    this.cmCodeObj = {
                        unitName: dataInfo.unitName || '',
                        platcmId: dataInfo.platcmId || '',
                    }
                    this.openSearch1('3391151360249856', 0, 'cmName', 'cmName,cmId')
                    break;
            }
        },
        // 华源重置
        hyResetInit() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    message: '请先选中一条要操作的数据',
                    type: 'error'
                });
                return false
            }
            this.$confirm('确定要重置吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: "info"
            }).then(async () => {
                const params = {
                    ids: this.multipleSelection.map(item => item.orderId),
                }
                const responseData = await this.$http.resetHyState(params)
                if (responseData.status == 200) {
                    this.$message.success(responseData.message)
                    this.getDataList()
                } else {
                    this.$message.error(responseData.message)
                }
            })
        },
        resetInit() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    message: '请先选中一条要操作的数据',
                    type: 'error'
                });
                return false
            }
            this.$confirm('确定要重置吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: "info"
            }).then(async () => {
                const params = {
                    ids: this.multipleSelection.map(item => item.orderId),
                }
                const responseData = await this.$http.resetInit(params)
                if (responseData.status == 200) {
                    this.$message.success(responseData.message)
                    this.getDataList()
                } else {
                    this.$message.error(responseData.message)
                }
            })
        },
        closePool() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    message: '请先选中一条要操作的数据',
                    type: 'error'
                });
                return false
            }
            this.$confirm('确定要关闭吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: "info"
            }).then(async () => {
                const params = {
                    ids: this.multipleSelection.map(item => item.orderId),
                }
                const responseData = await this.$http.orderpoolClosePool(params)
                if (responseData.status == 200) {
                    this.$message.success(responseData.message)
                    this.getDataList()
                } else {
                    this.$message.error(responseData.message)
                }
            })
        },
        del() {
            if (this.multipleSelection.length != 1) {
                this.$message({
                    message: '请先选中一条要操作的数据',
                    type: 'error'
                });
                return false
            }
            var dataInfo = this.multipleSelection[0]
            this.$confirm('确定要删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: "error"
            }).then(async () => {
                const params = {
                    ids: [dataInfo.orderId],
                }
                const responseData = await this.$http.orderpooldelete(params)
                if (responseData.status == 200) {
                    this.$message.success(responseData.message)
                    this.getDataList()
                } else {
                    this.$message.error(responseData.message)
                }
            })
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        showPrintPlan() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                var info = this.returnData.list[this.selectedDataIndex]
                this.$refs.printPlan.openDia(info.woamId)
            } else {
                return
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },


        // 获取数据列表
        async getDataList() {
            let responseData = this.activeName === "first" ? await this.$http.orderpoolQuerySpd(this.getRequestData) : await this.$http.orderpoolQuerySpd2(this.getRequestData)
            if (responseData && responseData.status == 200) {
                let resData = JSON.parse(JSON.stringify(responseData))
                this.returnData.list = resData.result.list
                this.returnData.pages = resData.result.pages
                this.returnData.total = resData.result.total
                this.returnData.pageNum = resData.result.pageNum
                this.selectedDataIndex = 0

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        //获取状态
        getIsGsp(str, val) {
            try {
                if (!str) return val;
                str = str.replace(/\\/g, '');
                let arr = JSON.parse(str);
                let len = arr.length;
                let newStr = '';
                for (let i = 0; i < len; i++) {
                    if (arr[i].key == val) {
                        newStr = arr[i].value;
                        break;
                    }
                }
                return newStr || val;
            } catch (ex) {
                return val;
            }
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()

            console.log(this.buttonList);
        },
        initTime() {
            this.getRequestData.start = this.$common.getStartTime()
            this.getRequestData.end = this.$common.getEndTime()
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
        this.initTime()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.bgmObj {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.bgmObj p {
    margin-right: 10px;
    margin-bottom: 10px;
    font-size: 16px;
}

.bgmObj p span:nth-child(1) {
    margin-right: 5px;
    color: #000;
    font-weight: bold;
}

.bgmObj p span:nth-child(2) {
    color: red;
}
</style>
